// src/store/features/message/messageActions.js:
import {
  ADD_MESSAGE,
  RECEIVE_MESSAGE,
  LOAD_MESSAGES,
  LOAD_MESSAGES_SUCCESS,
  LOAD_MESSAGES_FAIL,
  UPDATE_MESSAGE,
  DELETE_MESSAGE,
  DELETE_CHAT,
  DELETE_ALL_CHATS,
  SET_SELECTED_CHAT,
  SET_IS_NEW_CHAT,
  SET_IS_CHAT_FROM_RECENT_CHAT,
  GENERATE_PDF,
  RESET_GENERATE_PDF,
  CLEAR_ALL_CHAT,

  // TEXT LANGUAGE DETECTION STATES
  IS_TEXT_LANGUAGE_DETECTING,
  TEXT_LANGUAGE_DETECTION_DATA,
  TEXT_LANGUAGE_DETECTION_ERROR,

  // CONTENT GENERATION STATES
  IS_CONTENT_GENERATING,
  CONTENT_GENERATION_DATA,
  CONTENT_GENERATION_ERROR,
} from "./messageTypes";

export const addMessage = (message) => ({ type: ADD_MESSAGE, message });

export const receiveMessage = (message) => ({ type: RECEIVE_MESSAGE, message });

export const loadMessages = () => ({ type: LOAD_MESSAGES });

export const loadMessagesSuccess = (json, channel, date) => ({
  type: LOAD_MESSAGES_SUCCESS,
  json,
  channel,
  date,
});

export const loadMessagesFail = (error) => ({
  type: LOAD_MESSAGES_FAIL,
  error,
});

export const updateMessage = (chatId, messageId, updatedFields) => ({
  type: UPDATE_MESSAGE,
  payload: { chatId, messageId, updatedFields },
});

export const deleteMessage = (chatId, messageId) => ({
  type: DELETE_MESSAGE,
  chatId,
  messageId,
});

export const deleteChat = (chatId) => ({
  type: DELETE_CHAT,
  chatId,
});

export const deleteAllChats = () => ({
  type: DELETE_ALL_CHATS,
});

export const setSelectedChat = (chatId) => ({
  type: SET_SELECTED_CHAT,
  chatId,
});

export const setIsNewChat = (flag) => ({
  type: SET_IS_NEW_CHAT,
  payload: flag,
});

export const setIsChatFromRecentChat = (flag) => ({
  type: SET_IS_CHAT_FROM_RECENT_CHAT,
  payload: flag,
});

export const generatePdf = (chatId) => {
  return {
    type: GENERATE_PDF,
    payload: chatId,
  };
};

export const resetGeneratePdf = () => ({
  type: RESET_GENERATE_PDF,
});

export const clearAllChat = () => ({
  type: CLEAR_ALL_CHAT,
});

// TEXT LANGUAGE DETECTION
export const setIsTextLanguageDetecting = (flag) => ({
  type: IS_TEXT_LANGUAGE_DETECTING,
  payload: flag,
});

export const setTextLanguageDetectionData = (data) => ({
  type: TEXT_LANGUAGE_DETECTION_DATA,
  payload: data,
});

export const setTextLanguageDetectionError = (error) => ({
  type: TEXT_LANGUAGE_DETECTION_ERROR,
  payload: error,
});

// CONTENT GENERATION
export const setIsContentGenerating = (flag) => ({
  type: IS_CONTENT_GENERATING,
  payload: flag,
});

export const setContentGenerationData = (data) => ({
  type: CONTENT_GENERATION_DATA,
  payload: data,
});

export const setContentGenerationError = (error) => ({
  type: CONTENT_GENERATION_ERROR,
  payload: error,
});
